import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Icon } from 'semantic-ui-react';
import './styles.css';

const Venue = () => {
  const { t } = useTranslation();
  
  // Coordenadas de Vil·la Minerva, Sant Andreu de Llavaneres
  const mapUrl = "https://maps.google.com/maps?q=Vil·la+Minerva,+Camí+del+Pla+7,+08392+Sant+Andreu+de+Llavaneres,+Barcelona&output=embed";
  const googleMapsLink = "https://www.google.com/maps/search/?api=1&query=Vil·la+Minerva+Camí+del+Pla+7+08392+Sant+Andreu+de+Llavaneres+Barcelona";

  return (
    <div className="venue-wrapper">
      <Container>
        <p className="venue-intro">{t('venue.intro')}</p>
        
        <Grid stackable columns={2} className="venue-grid">
          <Grid.Row className="venue-main-row">
            <Grid.Column width={9} className="venue-info-column">
              <div className="venue-info-card">
                <div className="venue-info-header">
                  <Icon name="map marker alternate" className="venue-icon" />
                  <h3 className="venue-name">{t('events.dinner.venue')}</h3>
                </div>
                
                <div className="venue-address">
                  <p className="venue-address-line">
                    <Icon name="road" />
                    {t('events.dinner.address')}
                  </p>
                  <p className="venue-address-line">
                    <Icon name="building" />
                    {t('events.dinner.city')}
                  </p>
                </div>
                
                <div className="venue-actions">
                  <a 
                    href={googleMapsLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="venue-button"
                  >
                    <Icon name="location arrow" />
                    {t('venue.directions')}
                  </a>
                </div>
                
                <div className="venue-note">
                  <Icon name="info circle" />
                  <p>{t('venue.note')}</p>
                </div>
              </div>
            </Grid.Column>

            <Grid.Column width={7} className="venue-map-column">
              <div className="venue-map-container">
                <iframe
                  src={mapUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={t('venue.mapTitle')}
                  className="venue-map"
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </div>
  );
};

export default Venue;
